module.exports = __webpack_public_path__ + "static/media/profile_hidden.9349b5d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/06/profile_hidden.jpg
// module id = 416
// module chunks = 0